// extracted by mini-css-extract-plugin
module.exports = {"text":"FullText_text__2v8lq","container":"FullText_container__QN85n"};